<template>
  <b-container fluid class="competition-frame competition-steps">
    <b-row> <h1 class="text-left competition-top-row-position">Új pályázat</h1> </b-row>
    <b-row>
      <b-col md="1">
        <competition-step-progress />
      </b-col>
      <b-col md="11" class="pt-2">
        <b-row class="competition-col-pd"> <h4 class="pb-4">Alapadatok</h4> </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Cím">
              <b-form-input
                :value="stepOneValues.name"
                placeholder="Cím"
                @change="onChanged('name', $event)"
                type="text"
              ></b-form-input>
              <input-error :v-if="stepOneErrors.name.length > 0" :errors="stepOneErrors.name" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Kód">
              <b-form-input
                class="inputFieldAlign"
                :value="stepOneValues.code"
                placeholder="pl. GINOP 1.2.8-15"
                @change="onChanged('code', $event)"
                type="text"
              >
              </b-form-input>
              <input-error :v-if="stepOneErrors.code > 0" :errors="stepOneErrors.code"
            /></b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2 text-left">
          <b-col md="6">
            <b-form-group label="Pályázat listázóban való megjelenítés kezdete">
              <b-form-datepicker
                class="competition-datepicker-input"
                id="competition-release-date-start"
                locale="hu"
                reset-button
                label-reset-button="Törlés"
                label-help=""
                @input="onChanged('releaseDateStart', $event)"
                :value="stepOneValues.releaseDateStart"
                placeholder="Oldalon való megjelenés kezdete"
              ></b-form-datepicker>
              <input-error :v-if="stepOneErrors.releaseDateStart.length > 0" :errors="stepOneErrors.releaseDateStart"
            /></b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Pályázat listázóban való megjelenítés vége ">
              <b-form-datepicker
                class="competition-datepicker-input"
                locale="hu"
                reset-button
                label-reset-button="Törlés"
                label-help=""
                @input="onChanged('releaseDateEnd', $event)"
                :value="stepOneValues.releaseDateEnd"
                placeholder="Oldalon való megjelenés vége"
              ></b-form-datepicker>
              <input-error :v-if="stepOneErrors.releaseDateEnd.length > 0" :errors="stepOneErrors.releaseDateEnd"
            /></b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="12">
            <b-form-group label="Link">
              <b-form-input
                id="competition-link"
                class="inputFieldAlign"
                :value="stepOneValues.link"
                placeholder="Link"
                @change="onChanged('link', $event)"
                type="text"
              ></b-form-input>
              <input-error :v-if="stepOneErrors.link.length > 0" :errors="stepOneErrors.link"/></b-form-group
          ></b-col>
        </b-row>
        <b-row class="competition-step-button-row mt-2">
          <b-button class="competition-step-button" @click="save">Tovább</b-button>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import InputError from '../../../components/InputError.vue'
import CompetitionStepProgress from './CompetitionStepProgress.vue'
export default {
  name: 'CompetitionStepOne',
  components: { InputError, CompetitionStepProgress },
  created: function() {
    this.$store.commit('resetState')
    if (this.$route.query.competitionId) {
      this.$store.commit('setId', this.$route.query.competitionId)
    }
    this.$store.dispatch('initializeState', { step: 1 })
  },
  computed: {
    ...mapGetters(['id', 'stepOneValues', 'stepOneErrors'])
  },
  data: function() {
    return { item: null }
  },
  methods: {
    onChanged: function(key, value) {
      this.$store.commit('setValue', { step: 'stepOne', key, value })
    },
    save: function() {
      this.$store.dispatch('saveCompetition', { step: 1 })
    }
  }
}
</script>
<style>
#competition-release-date-end {
  border: 2px solid #b2bec3 !important;
  border-radius: 4px !important;
}
</style>
